import React, { ReactElement } from 'react'

export const Layout1Left2Right: React.FC = (): ReactElement => (
    <div className='layout1Left2Right'>
        <svg viewBox='0 0 30 30'>
            <path className='dashboard-layout-outer-border' d='M28,2V28H2V2H28m2-2H0V30H30V0Z' />
            <line className='central-border-line' x1='15' x2='15' y2='30' />
            <line className='central-border-line' x1='16' y1='15' x2='30' y2='15' />
            <rect
                className='dashboard-background-2 dashboard-layout-entry-square'
                x='16'
                y='2'
                width='12'
                height='12'
            />
            <text className='dashboard-foreground-2 dashboard-layout-entry-text' transform='translate(20.2 10.74)'>
                2
            </text>
            <rect
                className='dashboard-background-3 dashboard-layout-entry-square'
                x='16'
                y='16'
                width='12'
                height='12'
            />
            <text className='dashboard-foreground-3 dashboard-layout-entry-text' transform='translate(20.2 24.74)'>
                3
            </text>
            <rect className='dashboard-background-1 dashboard-layout-entry-square' x='2' y='2' width='12' height='26' />
            <text className='dashboard-foreground-1 dashboard-layout-entry-text' transform='translate(6.64 17.69)'>
                1
            </text>
        </svg>
    </div>
)
